import {Text} from 'src/v2/components/common';
import {useSelector} from 'src/v2/state/store';
import {tokens} from '@sail/ui';
import {message, useIntl} from '@sail/intl';

const messages = {
  disclaimer: message<{
    merchant: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.transaction_processing_time_disclaimer.disclaimer_message',

    description:
      'Dislaimer shown when transaction is processing and may take some time to complete.',

    defaultMessage:
      "It may take up to a minute to complete this transaction. You will be redirected back to {merchant} when it's complete.",
  }),
};

export const TransactionProcessingTimeDisclaimer = () => {
  const intl = useIntl();
  const businessName = useSelector(
    (state) => state.merchantBranding.businessName,
  );

  return (
    <Text
      type="caption"
      css={{textAlign: 'center', color: tokens.color.neutral[500].toString()}}
    >
      {intl.formatMessage(messages.disclaimer, {
        merchant: businessName,
      })}
    </Text>
  );
};
